import { commitSnackbar } from './snackbar.store'

function showSnackbar(
  message: string,
  color: string,
  durationMs?: number,
): void {
  commitSnackbar('SHOW', { message, color, durationMs })
}

export const SnackbarService = {
  info(message: string): void {
    showSnackbar(message, 'green')
  },
  warn(message: string): void {
    showSnackbar(message, 'orange')
  },
  /** @param durationMs for a message that takes longer to read than the default 3 s */
  error(message: string, durationMs?: number): void {
    showSnackbar(message, 'red', durationMs)
  },
}
